import AntdCollapse from 'antd/lib/collapse';
import React        from 'react';
import './InvisibleCollapse.scss';

export type InvisibleCollapseProps = React.ComponentProps<typeof AntdCollapse>;

const InvisibleCollapse = (props: InvisibleCollapseProps) => {
	return (
		<AntdCollapse
			accordion
			className={`widesk-invisible-collapse ${props.className || ''}`}
			ghost
			{...props}
		/>
	);
};

export default InvisibleCollapse;
